import Header from '../components/Header';
import Footer from '../components/Footer';
import '../main0.css';
import Restaurant from '../routes/Restaurant';
import Cafe from '../routes/Cafe';
import Blog from '../routes/Blog';
import Contact from '../routes/Contact';

const Home = (props) => {

  document.title = 'De School Amsterdam';

  if (props.headerTitle !== 'Restaurant DS') {document.querySelector('#formitableWidget')?.remove()}

  return (
    <div>
    <Header langNL={props.langNL} changeLang={props.changeLang}/>
  <div className="grid__container">
    <div className="grid__wrapper">
      <div className="grid grid__top grid-home">
      </div>
    </div>
  </div>

  <section className="info__container">
    <div className="info__container-header title-page-header page__home">
      <div className="page__header">
        <h1 className="page__header-title">
          <span className="ff">DE SCHOOL
          </span>
        </h1>
      </div>
    </div>
    <div className="info__container-content-grid page__home" style={{height: '0px'}}>
    </div>
  </section>
  <Footer isNL={props.langNL}/>
 <div id="outdated">
  <h6>Your browser is out-of-date!
  </h6>
  <p>Update your browser to view this website correctly.
    <a id="btnUpdateBrowser" href="http://outdatedbrowser.com/">  Update my browser now
    </a>

  </p>
</div>

<div id="fb-root">

</div>
    </div>


  );
}

export default Home;
